module.exports = __webpack_public_path__ + "img/02.c0bff56d.jpg";